









































import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';

import {ISystemLogService} from '@/services/system/ILog.service';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({})
export default class SystemKernelLogs extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ISystemLogService'))
  private systemLogService!: ISystemLogService;

  private kernelLog: any[] = [];

  private refreshing: boolean = false;

  private search: string = '';

  private kernelLogHeaders = [
    {
      text: 'Time',
      value: 'time',
      width: 200,
    },
    {
      text: 'Message',
      value: 'message',
    },
  ];

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.refreshing = true;

    try {
      const kernelLogLines = (await this.systemLogService.getKernelLog()).split('\n');

      // const timeRegex = /^\[ ?([\d.]+)\] ?/i;
      const timeRegex = /\[ ?(?<time>[^\]]+)\] ?/i;

      const kernelLog = [];
      for (let line of kernelLogLines) {
        if (line.length > 0) {

          const match = line.match(timeRegex);

          let time = 0;
          if (match !== null) {

            if (match.groups !== undefined) {
              time = +match.groups.time;
            }

            line = line.replace(timeRegex, '');
          }

          kernelLog.push({
            time,
            message: line,
          });
        }
      }

      this.kernelLog = kernelLog;

    } catch (error) {
      Notify.Error(this.logger, `Could not get kernel logs`, error);
    } finally {
      this.refreshing = false;
    }
  }
}
